
<template>
  <!-- 加载遮罩层 -->
  <div v-if="loading" class="loading-overlay">
    <!-- 加载内容 -->
    <div class="loading-content">
      <img src="@/assets/img/loading.gif" alt="加载中..." class="loading-gif" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingPage',
  props: {
    // 控制加载组件是否显示
    loading: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
/* 全屏遮罩层 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff; /* 白色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 998; /* 确保在最上层 */
  /* 可选：添加过渡效果 */
  transition: opacity 0.3s;
}

/* 加载内容容器 */
.loading-content {
  text-align: center;
}

/* GIF 图片样式 */
.loading-gif {
  width: 80px;
  height: 80px;
  /* 可根据你的 GIF 调整大小 */
}
</style>